import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { ModuleDialogs } from '../../constants/Dialogs';

import Dialog from '../Common/Dialog';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import DialogStore from '../../stores/DialogStore';
import DialogActions from '../../actions/DialogActionCreator';

const statuses = [
    { name: 'waiting',   label: 'waiting' },
    { name: 'attending', label: 'attending' },
    { name: 'attended',  label: 'attended' },
    { name: 'did_not_attend', label: 'did not attend' }
];

const validate = draft => {
    let errors = {};
    if (draft.number !== '') {
        const score = Number(draft.score);
        if (isNaN(score)) {
            errors.score = 'Score must be a number';
        } else if (0 > score || score > 100) {
            errors.score = 'Score must be between 0 and 100';
        }
    }

    if (!draft.attendanceStatus) {
        errors.attendanceStatus = 'Required field';
    } else if (!statuses.find(({name}) => name === draft.attendanceStatus)) {
        errors.attendanceStatus = 'Invalid status';
    }

    return errors;
};

class ModuleEventAttendeeDialog extends Component {
    render() {
        const dialogProps = {
            title:      'Edit attendance',
            open:       this.state.open === ModuleDialogs.MODULE_EVENT_SCORE,
            isValid:    this.state.isValid,
            onSave:     this.props.onSave
        };

        return (
            <Dialog {...dialogProps} >
                <SelectField
                    name="attendanceStatus"
                    floatingLabelText="Attendance"
                    value={this.state.draft.attendanceStatus}
                    errorText={this.state.errors.attendanceStatus}
                    onChange={this.onAttendanceChange}
                    fullWidth={true}
                >
                    {statuses.map(({name, label}) => <MenuItem key={name} value={name} primaryText={label} />)}
                </SelectField>
                <TextField
                    name="score"
                    floatingLabelText="Score"
                    value={this.state.draft.score}
                    onChange={this.onTextChange}
                    errorText={this.state.errors.score}

                />
            </Dialog>
        );
    }

    onTextChange({target}) {
        if (!target.name) { return; } //guard
        DialogActions.updateDraft(target.name, target.value);
    }

    onAttendanceChange({target}, index, value) {
        DialogActions.updateDraft('attendanceStatus', value);
    }
}

ModuleEventAttendeeDialog.getStores = () => ([DialogStore]);
ModuleEventAttendeeDialog.calculateState = (prevState) => {
    const {open, draft} = DialogStore.getState();
    const errors = validate(draft);
    return {
        open,
        draft,
        errors,
        isValid: (Object.keys(errors).length === 0)
    }
};

ModuleEventAttendeeDialog.propTypes = {
    onSave:     PropTypes.func
};
export default Container.create(ModuleEventAttendeeDialog);
